// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/css/async/" + chunkId + "." + {"2498": "ecc5f3c4","4360": "dec96c30",}[chunkId] + ".css"
}